import PageQuestions from './PageQuestions';



export default PageQuestions;
